import Vuex from 'vuex';
// Referencing the index file explicitly shouldn't
// be a thing, not sure what's going on here...
import search from './modules/search';
import booking from './modules/booking';
import listing from './modules/listing';
import space from './modules/space';
import landlordReservations from './modules/landlord-reservations';
import global from './modules/global';
import user from './modules/user';
import autopay from './modules/autopay';

export default new Vuex.Store({
    modules: {
        search,
        booking,
        listing,
        space,
        'landlord-reservations': landlordReservations,
        global,
        user,
        autopay,
    },
    strict: false,
});

